document.addEventListener('DOMContentLoaded', function() {
// Get all links that have a hash (#) in them
const links = document.querySelectorAll('a[href^="#"]');

// Add click event listener to each link
links.forEach(link => {
  link.addEventListener('click', function(e) {
    // Prevent default anchor behavior
    e.preventDefault();
    
    // Get the target section ID from the href
    const targetId = this.getAttribute('href').substring(1);
    javascript
    
    // Find the element with that ID
    const targetElement = document.getElementById(targetId);

    // Also look for elements with matching data-section-id
    if (!targetElement) {
    targetElement = document.querySelector(`[data-section-id="${targetId}"]`);
    }
    
    // If the element exists, scroll to it
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 80, // Offset for header
        behavior: 'smooth'
      });
    }
  });
});
});
